import { QueryClient } from "@tanstack/react-query";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        retry: (failureCount, error) => {
          // Never retry auth/permission failures — they will not fix themselves.
          const code = (error as { data?: { code?: string } })?.data?.code;
          if (code === "UNAUTHORIZED" || code === "FORBIDDEN") return false;
          return failureCount < 2;
        },
      },
      mutations: { retry: 0 },
    },
  });
}
